import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';
const valEmp = __CONFIG__.empresa;

const LISTADO_REGISTRO = 'LISTADO_REGISTRO';
const GUARDAR_REGISTRO = 'GUARDAR_REGISTRO';
const LOADER = 'LOADER';
const MODULO = 'MODULO';
const LISTADO_PRODUCTO = 'LISTADO_PRODUCTO';
const LISTADO_FABRICANTE = 'LISTADO_FABRICANTE';
const LISTADO_ACONDICIONADOR = 'LISTADO_ACONDICIONADOR';
const LISTADO_CLASIFICACION = 'LISTADO_CLASIFICACION';
const PAIS = 'PAIS';
const LISTADO_PAISES = 'LISTADO_PAISES';
const LISTADO_COMERCIALIZADOR = 'LISTADO_COMERCIALIZADOR';
const LISTADO_PAISES_ORIGEN = 'LISTADO_PAISES_ORIGEN';
const LISTADO_LICENCIAS = 'LISTADO_LICENCIAS';
const LISTADO_VIA = 'LISTADO_VIA';
const LISTADO_TIPOS_REGISTRO = 'LISTADO_TIPOS_REGISTRO';
const CODIGO_PAIS = 'CODIGO_PAIS';
const LISTADO_REGISTRO_PRODUCTO = 'LISTADO_REGISTRO_PRODUCTO';
const CONSULTA_REGISTRO = 'CONSULTA_REGISTRO';
const PARAMETRO = 'PARAMETRO';
const CODIGO_UNIFICACION = 'CODIGO_UNIFICACION';
const LISTADO_ELZM = 'LISTADO_ELZM';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = (pais) => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id, pais };
    
    dispatch(setLoader(true));
    api.get('/rs_registro_sanitario_renovacion', params).then((response)=>{
        dispatch({ type: LISTADO_REGISTRO, data: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar productos',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroRS = (data = {}, attachments = [], productoPais) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormRegistroSanitarioRenovacion.values;
    
    let id_empresa = id_emp[5]
    let pais = id_emp[7]
    
    if (data === undefined) {
        Swal.fire({
            title: 'Registro sanitario renovación',
            text: 'Debe de seleccionar un producto',
            type: 'error',
        })
    } else {
        if (data.producto === undefined || data.producto === '') {
            Swal.fire({
                title: 'Registro sanitario renovación',
                text: 'Debe de seleccionar un producto',
                type: 'error',
            })
        } else {
            if (data.fabricante === undefined || data.fabricante === '') {
                Swal.fire({
                    title: 'Registro sanitario renovación',
                    text: 'Debe de seleccionar un fabricante',
                    type: 'error',
                })
            } else {
                if (data.acondicionador === undefined || data.acondicionador === '') {
                    Swal.fire({
                        title: 'Registro sanitario renovación',
                        text: 'Debe de seleccionar un acondicionador',
                        type: 'error',
                    })
                } else {
                    if (data.clasificacion === undefined || data.clasificacion === '') {
                        Swal.fire({
                            title: 'Registro sanitario renovación',
                            text: 'Debe de seleccionar una clasificación',
                            type: 'error',
                        })
                    } else {
                        if (data.fecha_enviado === undefined || data.fecha_enviado === '') {
                            Swal.fire({
                                title: 'Registro sanitario renovación',
                                text: 'Debe de ingresar una fecha de enviado',
                                type: 'error',
                            })
                        } else {
                            if (data.tipo_registro === undefined || data.tipo_registro === ''){
                                Swal.fire({
                                    title: 'Registro sanitario renovación',
                                    text: 'Debe de seleccionar un tipo de registro',
                                    type: 'error',
                                })
                            }else{
                                const formData = {
                                    producto: data.producto.value,
                                    fabricante: data.fabricante.value,
                                    pais_fabricante: data.pais_fabricacion,
                                    acondicionador: data.acondicionador.value,
                                    titular: data.titular,
                                    clasificacion: data.clasificacion.value,
                                    fecha_enviado: data.fecha_enviado,
                                    fecha_sometido: data.fecha_sometido,
                                    fecha_estimada: data.fecha_estimada_registro,
                                    pais: pais,
                                    vida_util: data.vida_util,
                                    licencia: data.licencia,
                                    via: data.via,
                                    tipo_registro: data.tipo_registro,
                                    descripcionProducto: productoPais,
                                    empresa: id_empresa,
                                    observacion: data.observacion,
                                }
                                dispatch(setLoader(true));
                                api.postAttachments('/rs_registro_sanitario_renovacion/', formData, attachments).then(() => {
                                    NotificationManager.success(
                                    'Renovación de registro sanitario creado correctamente',
                                    'Exito',
                                    3000
                                );
                                let ruta = `/registro_sanitario/${id_emp[5]}/registro_renovacion/${id_emp[7]}`
                                dispatch(push(ruta));
                                }).catch((error) => {
                                    NotificationManager.error(
                                        error.msj,
                                        'Error',
                                        2000
                                    );
                                }).finally(() => {
                                    dispatch(setLoader(false));
                                });
                            }
                        }
                    }
                }
            }
        }
    }
}

export const modificarRS = (data = {}, attachments = []) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormRegistroSanitarioRenovacion.values;
    
    const id = datos.id;
    if (datos === undefined) {
        Swal.fire({
            title: 'Registro sanitario renovación',
            text: 'Debe de seleccionar un producto',
            type: 'error',
        })
    } else {
        if (datos.producto === undefined || datos.producto === '') {
            Swal.fire({
                title: 'Registro sanitario renovación',
                text: 'Debe de seleccionar un producto',
                type: 'error',
            })
        } else {
            if (datos.fabricante === undefined || datos.fabricante === '') {
                Swal.fire({
                    title: 'Registro sanitario renovación',
                    text: 'Debe de seleccionar un fabricante',
                    type: 'error',
                })
            } else {
                if (datos.acondicionador === undefined || datos.acondicionador === '') {
                    Swal.fire({
                        title: 'Registro sanitario renovación',
                        text: 'Debe de seleccionar un acondicionador',
                        type: 'error',
                    })
                } else {
                    if (datos.clasificacion === undefined || datos.clasificacion === '') {
                        Swal.fire({
                            title: 'Registro sanitario renovación',
                            text: 'Debe de seleccionar una clasificación',
                            type: 'error',
                        })
                    } else {
                        if (datos.fecha_enviado === undefined || datos.fecha_enviado === '') {
                            Swal.fire({
                                title: 'Registro sanitario renovación',
                                text: 'Debe de ingresar una fecha de enviado',
                                type: 'error',
                            })
                        } else {
                            if (datos.tipo_registro === undefined || datos.tipo_registro === '' || datos.tipo_registro === null) {
                                Swal.fire({
                                    title: 'Registro sanitario renovación',
                                    text: 'Debe de seleccionar un tipo de registro',
                                    type: 'error',
                                })
                            } else {
                                let pais_fabricante = datos.pais_fabricacion;
                                if (pais_fabricante === undefined) {
                                    pais_fabricante = datos.pais_fabricante;
                                } else {
                                    pais_fabricante = datos.pais_fabricacion;
                                }

                                let via_admin = datos.via;
                                if (via_admin === undefined) {
                                    via_admin = datos.via_administracion;
                                } else {
                                    via_admin = datos.via;
                                }
                                const formData = {
                                    id: id,
                                    producto: datos.producto,
                                    fabricante: datos.fabricante,
                                    pais_fabricante: pais_fabricante,
                                    acondicionador: datos.acondicionador,
                                    titular: datos.titular,
                                    clasificacion: datos.clasificacion,
                                    fecha_enviado: datos.fecha_enviado,
                                    fecha_sometido: datos.fecha_sometido,
                                    fecha_estimada: datos.fecha_estimada_registro,
                                    vida_util: datos.vida_util,
                                    licencia: datos.licencia,
                                    via: via_admin,
                                    tipo_registro: datos.tipo_registro,
                                    descripcionProducto: datos.descripcion_producto,
                                    observacion: datos.observacion,
                                }
                                dispatch(setLoader(true));
                                api.putAttachments(`/rs_registro_sanitario_renovacion/${id}/`, formData, attachments).then(() => {
                                    NotificationManager.success(
                                        'Renovación de registro sanitario modificado correctamente',
                                        'Exito',
                                        3000
                                    );
                                    let ruta = `/registro_sanitario/${id_emp[5]}/registro_renovacion/${id_emp[7]}`
                                        dispatch(push(ruta));
                                }).catch((error) => {
                                    NotificationManager.error(
                                        'Ocurrió un error al modificar renovación registro sanitario',
                                        'Error',
                                        2000
                                    );
                                }).finally(() => {
                                    dispatch(setLoader(false));
                                });
                            }
                        }
                    }
                }
            }
        }
    }
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/rs_registro_sanitario_renovacion/${id}`).then((response) => {
        let ruta = window.location.href;
        let id_emp = ruta.split('/');
        let producto = response.producto;
        let fabricante = response.fabricante;
        let id = id_emp[5];
        let params = { id, producto, fabricante };
        
        dispatch(setLoader(true));
        api.get('/rs_registro_sanitario_renovacion/consultaRegistroSanitario/', params).then((response)=>{
            dispatch({ type: CONSULTA_REGISTRO, registroProducto: response.registro });
        }).catch((error) => {
            NotificationManager.error(
                error.msj,
                'Error',
                2000
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
        dispatch(initializeForm('FormRegistroSanitarioRenovacion', response ));
        dispatch({ type: GUARDAR_REGISTRO, lectura: response });
    }).catch((error)=>{
        
        NotificationManager.error(
            'Ocurrió un error al consultar renovación registro sanitario',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const listarProductos = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id };
    }else{
        id = id_emp[5];
        params = { id };
    }
    return api.get("/rs_producto", params).then(response => {
        const producto = [];
        response.forEach(item => {
            producto.push({
                value: item.id,
                label: item.descripcion
            })
        })
        dispatch({ type: LISTADO_PRODUCTO, listaPro: producto });
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar productos',
            'Error',
            8000
        );
    })
}

const buscarProductos = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id, search };
    }else{
        id = id_emp[5];
        params = { id, search };
    }
    return api.get("/rs_producto/productos_rs", params).then(response => {
        const producto = [];
        response.forEach(item => {
            producto.push({
                value: item.id,
                label: item.descripcion
            })
        })
        return producto;
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar productos',
            'Error',
            8000
        );
    })
}

const listarFabricante = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id };
    }else{
        id = id_emp[5];
        params = { id };
    }
    return api.get("/fabricante", params).then(response => {
        const fabricante = [];
        response.forEach(item => {
            fabricante.push({
                value: item.id,
                label: item.descripcion
            })
        })
        dispatch({ type: LISTADO_FABRICANTE, listaFab: fabricante });
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar fabricantes',
            'Error',
            8000
        );
    })
}

const buscarFabricante = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id, search };
    }else{
        id = id_emp[5];
        params = { id, search };
    }
    return api.get("/fabricante/fabricante_rs", params).then(response => {
        const fabricante = [];
        response.forEach(item => {
            fabricante.push({
                value: item.id,
                label: item.descripcion
            })
        })
        return fabricante;
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar fabricantes',
            'Error',
            8000
        );
    })
}

const listarAcondicionadores = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id };
    }else{
        id = id_emp[5];
        params = { id };
    }
    return api.get("/acondicionador", params).then(response => {
        const acond = [];
        response.forEach(item => {
            acond.push({
                value: item.id,
                label: item.descripcion
            })
        })
        dispatch({ type: LISTADO_ACONDICIONADOR, listaAcond: acond });
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar acondicionadores',
            'Error',
            8000
        );
    })
}

const buscarAcondicionador = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id, search };
    }else{
        id = id_emp[5];
        params = { id, search };
    }
    return api.get("/acondicionador/acondicionador_rs", params).then(response => {
        const fabricante = [];
        response.forEach(item => {
            fabricante.push({
                value: item.id,
                label: item.descripcion
            })
        })
        return fabricante;
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar acondicionadores',
            'Error',
            8000
        );
    })
}


const listarClasificacion = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id };
    }else{
        id = id_emp[5];
        params = { id };
    }
    return api.get("/clasificacion", params).then(response => {
        const clasificacion = [];
        response.forEach(item => {
            clasificacion.push({
                value: item.id,
                label: item.descripcion_corta
            })
        })
        dispatch({ type: LISTADO_CLASIFICACION, listaClasificacion: clasificacion });
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar clasificaciones',
            'Error',
            8000
        );
    })
}


const buscarClasificacion = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id, search };
    }else{
        id = id_emp[5];
        params = { id, search };
    }
    return api.get("/clasificacion/clasificacion_rs", params).then(response => {
        const clasificacion = [];
        response.forEach(item => {
            clasificacion.push({
                value: item.id,
                label: item.descripcion_corta
            })
        })
        return clasificacion;
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar clasificaciones',
            'Error',
            8000
        );
    })
}


export const getPais = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/pais_registro/${id}`).then((response)=>{
        dispatch({ type: PAIS, paisN: response.paisNombre });
        dispatch({ type: CODIGO_PAIS, codigoPais: response.codigoPais });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar pais',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const listarPaises = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id;
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id };
    }else{
        id = id_emp[5];
        params = { id };
    }
    return api.get("/pais_registro", params).then(response => {
        const paisR = [];
        response.forEach(item => {
            paisR.push({
                value: item.id,
                label: item.paisNombre.toUpperCase()
            })
        })
        dispatch({ type: LISTADO_PAISES, pais: paisR });
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar paises',
            'Error',
            8000
        );
    })
}

const listarComercializador = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage') {
        id = id_emp[6];
        params = { id };
    } else {
        id = id_emp[5];
        params = { id };
    }
    return api.get("/comercializador", params).then(response => {
        const fabricante = [];
        response.forEach(item => {
            fabricante.push({
                value: item.id,
                label: item.comercializador
            })
        })
        dispatch({ type: LISTADO_COMERCIALIZADOR, listaCom: fabricante });
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar comercializadores',
            'Error',
            8000
        );
    })
}

const listarPaisesOrigen = () => (dispatch) => {
    return api.get("/paises").then(response => {
        const pais = [];
        response.results.forEach(item => {
            pais.push({
                value: item.id,
                label: item.pais.toUpperCase()
            })
        })
        dispatch({ type: LISTADO_PAISES_ORIGEN, listaPaisOrigen: pais });
    })
}

const listarLicencias = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id;
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id };
    }else{
        id = id_emp[5];
        params = { id };
    }
    return api.get("/rs_licencia", params).then(response => {
        const licencia = [];
        response.forEach(item => {
            licencia.push({
                value: item.id,
                label: item.descripcion
            })
        })
        dispatch({ type: LISTADO_LICENCIAS, lic: licencia });
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar paises',
            'Error',
            8000
        );
    })
}

const listarVias = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage') {
        id = id_emp[6];
        params = { id };
    } else {
        id = id_emp[5];
        params = { id };
    }
    return api.get("/via_admin", params).then(response => {
        const via = [];
        response.forEach(item => {
            via.push({
                value: item.id,
                label: item.descripcion
            })
        })
        dispatch({ type: LISTADO_VIA, listaVia: via });
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar vias de administración',
            'Error',
            8000
        );
    })
}

const listarTiposRegistro = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id;
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id };
    }else{
        id = id_emp[5];
        params = { id };
    }
    return api.get("/rs_tipo_registro", params).then(response => {
        const licencia = [];
        response.forEach(item => {
            licencia.push({
                value: item.id,
                label: item.descripcion
            })
        })
        dispatch({ type: LISTADO_TIPOS_REGISTRO, tipoRegistro: licencia });
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar paises',
            'Error',
            8000
        );
    })
}

export const datoRegistro = (fabricante) => (dispatch, getStore) => {
    const datos = getStore().form.FormRegistroSanitarioRenovacion.values; 
    if (datos === undefined){
        Swal.fire({
            title: 'Registro sanitario renovación',
            text: 'Debe de seleccionar un producto',
            type: 'error',
        })
    }else{
        if (fabricante === undefined || fabricante === '0'){
            Swal.fire({
                title: 'Registro sanitario renovación',
                text: 'Debe de seleccionar un fabricante',
                type: 'error',
            })
        }else{
            if (datos.producto === undefined || datos.producto === ''){
                Swal.fire({
                    title: 'Registro sanitario renovación',
                    text: 'Debe de seleccionar un producto',
                    type: 'error',
                })
            }else{
                let producto = datos.producto.value;
                let ruta = window.location.href;
                let id_emp = ruta.split('/');
                let id = id_emp[5];
                let params = { id, producto, fabricante };
                
                dispatch(setLoader(true));
                api.get('/rs_registro_sanitario_renovacion/consultaRegistroSanitario/', params).then((response)=>{
                    dispatch({ type: LISTADO_REGISTRO_PRODUCTO, listRegistroProducto: response.registro });
                }).catch((error) => {
                    NotificationManager.error(
                        error.msj,
                        'Error',
                        2000
                    );
                }).finally(() => {
                    dispatch(setLoader(false));
                });
            }
        }
    }
};

export const descripcionProducto = (id) => (dispatch) => {
    dispatch(setLoader(true));
    return api.get(`/rs_producto/${id}`).then((response)=>{
        dispatch({ type: CODIGO_UNIFICACION, codigo_unificacion: response.codigo_unificacion });
        return response.descripcion;
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar producto',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const eliminarRegistro = id => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let pais = ''
    if (valEmp === 'fage'){
        pais = id_emp[8];
    }else{
        pais = id_emp[7];
    }
    dispatch(setLoader(true));
    api.eliminar(`/rs_registro_sanitario_renovacion/${id}`).then(() => {
        dispatch(listar(pais));
        NotificationManager.success(
            'Registro sanitario borrado correctamente',
            'Exito',
            3000
        );
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar renovación registro sanitario',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const limpiarDatos = () => (dispatch) => {
    dispatch(initializeForm('FormRegistroSanitarioRenovacion'));
    dispatch({ type: CONSULTA_REGISTRO, registroProducto: '' });
    dispatch({ type: CODIGO_UNIFICACION, codigo_unificacion: '' });
};

export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id}
    dispatch(setLoader(true));
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({type: PARAMETRO, datos: response });
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

const listarELZM = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id };
    
    return api.get("/rs_elzm", params).then(response => {
        const elzm = [];
        response.forEach(item => {
            elzm.push({
                value: item.id,
                label: item.codigo_letra + ' -- ' + item.familia_nuclear + ' -- ' + item.fabricante + ' -- ' + item.marca
            })
        })
        dispatch({ type: LISTADO_ELZM, listaELZM: elzm });
    }).catch(error => {
        NotificationManager.error(
            'Ocurrió un error al listar ELZM',
            'Error',
            8000
        );
    })
}

export const actions = {
    listar,
    registroRS,
    modificarRS,
    leer,
    getModulo,
    listarProductos,
    listarAcondicionadores,
    listarFabricante,
    listarClasificacion,
    getPais,
    listarPaises,
    listarComercializador,
    listarPaisesOrigen,
    listarLicencias,
    listarVias,
    listarTiposRegistro,
    datoRegistro,
    descripcionProducto,
    buscarProductos,
    buscarFabricante,
    buscarAcondicionador,
    buscarClasificacion,
    eliminarRegistro,
    limpiarDatos,
    parametrosEmpresa,
    listarELZM
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_REGISTRO]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [LISTADO_PRODUCTO]: (state, { listaPro }) => {
        return {
            ...state,
            listaPro,
        };
    },
    [LISTADO_FABRICANTE]: (state, { listaFab }) => {
        return {
            ...state,
            listaFab,
        };
    },
    [LISTADO_ACONDICIONADOR]: (state, { listaAcond }) => {
        return {
            ...state,
            listaAcond,
        };
    },
    [LISTADO_CLASIFICACION]: (state, { listaClasificacion }) => {
        return {
            ...state,
            listaClasificacion,
        };
    },
    [GUARDAR_REGISTRO]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [PAIS]: (state, { paisN }) => {
        return {
            ...state,
            paisN,
        };
    },
    [LISTADO_PAISES]: (state, { pais }) => {
        return {
            ...state,
            pais,
        };
    },
    [LISTADO_COMERCIALIZADOR]: (state, { listaCom }) => {
        return {
            ...state,
            listaCom,
        };
    },
    [LISTADO_PAISES_ORIGEN]: (state, { listaPaisOrigen }) => {
        return {
            ...state,
            listaPaisOrigen,
        };
    },
    [LISTADO_LICENCIAS]: (state, { lic }) => {
        return {
            ...state,
            lic,
        };
    },
    [LISTADO_VIA]: (state, { listaVia }) => {
        return {
            ...state,
            listaVia,
        };
    },
    [LISTADO_TIPOS_REGISTRO]: (state, { tipoRegistro }) => {
        return {
            ...state,
            tipoRegistro,
        };
    },
    [CODIGO_PAIS]: (state, { codigoPais }) => {
        return {
            ...state,
            codigoPais,
        };
    },
    [LISTADO_REGISTRO_PRODUCTO]: (state, { listRegistroProducto }) => {
        return {
            ...state,
            listRegistroProducto,
        };
    },
    [CONSULTA_REGISTRO]: (state, { registroProducto }) => {
        return {
            ...state,
            registroProducto,
        };
    },
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
    [CODIGO_UNIFICACION]: (state, { codigo_unificacion }) => {
        return {
            ...state,
            codigo_unificacion,
        };
    },
    [LISTADO_ELZM]: (state, { listaELZM }) => {
        return {
            ...state,
            listaELZM,
        };
    },
};

export const initialState = {
    loader: false,
    modulo: [],
    lectura: [],
    listaPro: [],
    listaAcond: [],
    listaFab: [],
    listaClasificacion: [],
    data: [],
    paisN: '',
    pais: [],
    listaCom: [],
    listaPaisOrigen: [],
    lic: [],
    listaVia: [],
    tipoRegistro: [],
    codigoPais: '',
    listRegistroProducto: '',
    registroProducto: '',
    datos: [],
    codigo_unificacion: '',
    listaELZM : [],
};

export default handleActions(reducers, initialState)
 